import { render, staticRenderFns } from "./Navigationbar.vue?vue&type=template&id=13dda336&scoped=true&"
import script from "./Navigationbar.vue?vue&type=script&lang=ts&"
export * from "./Navigationbar.vue?vue&type=script&lang=ts&"
import style0 from "./Navigationbar.vue?vue&type=style&index=0&id=13dda336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dda336",
  null
  
)

export default component.exports